export { default } from './SlideshowSetupContainer';
